import React, { useState, useEffect } from 'react';
import api from '../api';
import { Clock } from 'lucide-react';

const fmtDuration = (s) => {
  const h = Math.floor((s || 0) / 3600);
  const m = Math.round(((s || 0) % 3600) / 60);
  return h ? `${h}h ${m}m` : `${m}m`;
};

export default function PortalActivity() {
  const [activity, setActivity] = useState(null);

  useEffect(() => {
    api.get('/users/activity')
      .then(r => setActivity(Array.isArray(r.data) ? r.data : []))
      .catch(() => setActivity([]));
  }, []);

  return (
    <div style={{ padding: 24 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 18 }}>
        <Clock size={20} color="#0284c7" />
        <h1 style={{ fontSize: 20, fontWeight: 700, color: '#1e293b', margin: 0 }}>Time on Portal</h1>
      </div>

      {activity === null && (
        <div style={{ color: '#94a3b8', fontSize: 13 }}>Loading...</div>
      )}

      {activity && activity.length === 0 && (
        <div style={{ color: '#94a3b8', fontSize: 13 }}>No activity recorded yet.</div>
      )}

      {activity && activity.length > 0 && (
        <div style={{ background: '#fff', borderRadius: 12, boxShadow: '0 1px 3px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 100px 100px 100px', padding: '10px 18px', fontSize: 11, fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', background: '#f8fafc' }}>
            <div>User</div><div>Today</div><div>This week</div><div>This month</div>
          </div>
          {activity.map(a => (
            <div key={a.id} style={{ display: 'grid', gridTemplateColumns: '1fr 100px 100px 100px', alignItems: 'center', padding: '12px 18px', borderTop: '1px solid #f1f5f9', fontSize: 13 }}>
              <div style={{ color: '#1e293b', fontWeight: 500 }}>{a.name}</div>
              <div style={{ color: '#64748b' }}>{fmtDuration(a.today_seconds)}</div>
              <div style={{ color: '#64748b' }}>{fmtDuration(a.week_seconds)}</div>
              <div style={{ color: '#64748b' }}>{fmtDuration(a.month_seconds)}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
